<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>

    <MensagemAlerta class="row-space" v-if="msgEdicao" :mensagem="msgEdicao" />
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div v-if="!showOsView && !showPessoaSelect" class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Produtor</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(pessoaSelecionada.cdpessoa) }}</div>
            </div>

            <div class="form-item flexible">
                <label class="label-caption">Nome</label>
                <div class="field-label">{{ pessoaSelecionada.nmpessoa }}</div>
            </div>

            <div class="form-item-char20">
                <label v-if="!ckCpfCnpjOk" class="label-link" @click="showModalCpfCnpj=true">CPF/CNPJ</label>
                <label v-if="ckCpfCnpjOk" class="label-caption">CPF/CNPJ</label>
                <div :class="{
                    'field-label-alert': !ckCpfCnpjOk,
                    'field-label': ckCpfCnpjOk,
                    'field-label-center': true}">{{ pessoaSelecionada.cpfcnpj }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-link" @click="showModalFone=true">Fone</label>
                <div class="field-label field-label-center">{{ pessoaSelecionada.fone }}</div>
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Inscrição Estadual</label>
                <div class="field-label field-label-center">{{ pessoaStatus.produtor_inscricao }}</div>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Produtor Ativo</label>
                <div :class="{
                    'field-label-alert': pessoaStatus.produtor_sn=='N',
                    'field-label': pessoaStatus.produtor_sn!='N',
                    'field-label-center': true
                }">{{ pessoaStatus.produtor_sn }}</div>
            </div>


            <div class="form-item-char20">
                <label class="label-caption">Valor À Emitir</label>
                <div :class="{
                    'field-label-alert': pessoaStatus.financeiro_aemitir,
                    'field-label': !pessoaStatus.financeiro_aemitir,
                    'field-label-end': true
                }">{{ Funcoes.formatDecimal(pessoaStatus.financeiro_aemitir) }}</div>
            </div>
            
            <div class="form-item-char20">
                <label class="label-caption">Valor Vencido</label>
                <div :class="{
                    'field-label-alert': pessoaStatus.financeiro_vencido,
                    'field-label': !pessoaStatus.financeiro_vencido,
                    'field-label-end': true
                }">{{ Funcoes.formatDecimal(pessoaStatus.financeiro_vencido) }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Saldo Banco</label>
                <div :class="{
                    'field-label-alert': pessoaStatus.saldo_vlbanco < 0,
                    'field-label': pessoaStatus.saldo_vlbanco >= 0,
                    'field-label-end': true
                }">{{ Funcoes.formatDecimal(pessoaStatus.saldo_vlbanco) }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Horas Aguardando</label>
                <div class="field-label field-label-center">{{ pessoaStatus.osst2_hrstring }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Saldo de Horas</label>
                <div class="field-label field-label-center">{{ pessoaStatus.saldo_hrstring }}</div>
            </div>
        </div>
    </div>


    <div v-if="!showOsView && !showPessoaSelect" class="form-edit-page">
        <form @submit.prevent="submitForm">
            <div class="row row-space">
                <EquipamentoGrupoSelect class="form-item" 
                    :ckStatus="true"
                    v-model:idSelecionado="idGrupo"
                    @update:objSelecionado="atualizarGrupo" required />
                <EquipamentoSelect :ckPesquisar="false" :flagTipo="1" :idGrupo="idGrupo" class="form-item" 
                    v-model:idSelecionado="idEquipamento"
                    @update:equipamentoSelecionadoObj="atualizarEquipamento" />
                <EquipamentoSelect :descCaption= "'Implemento'" :flagTipo="2" class="form-item"
                    v-model:idSelecionado="idImplemento"
                    @update:equipamentoSelecionadoObj="atualizarImplemento" />
            </div>
            

            <div class="row row-space">
                <PropriedadeSelect v-if="showPropriedade" class="form-item" 
                    :idPessoa="pessoaSelecionada.id" 
                    v-model:idSelecionado="idPropriedade"
                    @update:objSelecionado="atualizarPropriedade" />

                <div v-if="showPropriedade" class="form-item flexible">
                    <label class="label-caption">Localidade</label>
                    <div class="field-label">{{ propriedadeSelecionada?.nmlocalidade || '' }}</div>
                </div>
                
                <div v-if="!showPropriedade" class="form-item">
                    <LocalidadeSelect class="form-item" v-model:idSelecionado="idLocalidade" required />
                </div>


                <div class="form-item">
                    <label class="label-caption">Complemento/referência</label>
                    <input type="text" v-model="edLocalidadeComplemento" maxlength="100" v-uppercase />
                </div>
            </div>
            
            
            <div class="row row-space">
                <ServicoSelect class="form-item" v-model:idSelecionado="idServico" required />

                <div class="form-item">
                    <label class="label-caption">Descrição Serviço</label>
                    <input type="text" v-model="edDescricao" maxlength="100" v-uppercase />
                </div>
                
                <div class="form-item-char30">
                    <CulturaSelect class="form-item" v-model:culturaSelecionada="idCultura" />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Hectares</label>
                    <input type="text" class="input-right" v-model="edHectares" v-decimal-mask maxlength="10"/>
                </div>

                <div class="form-item">
                    <label class="label-caption">Valor Hora</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatDecimal(vlHora) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Vl Implemento</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatDecimal(vlHoraImplemento) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Hr Contratadas</label>
                    <input type="text" class="input-center" v-time-mask v-model="edHrContratada" required />
                </div>

                <div v-if="(pessoaStatus) && (pessoaStatus.saldo_minutos > 0)" class="form-item">
                    <label class="label-caption">Hr Bonificadas</label>
                    <input type="text" class="input-center" v-time-mask v-model="edHrCtBanco" />
                </div>

                <div class="form-item">
                    <label class="label-caption">Hr Pagto</label>
                    <div class="field-label field-label-center">{{ edHrCtPagamento }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Valor Total</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatDecimal(vlTotal) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Agendamento</label>
                    <input type="date" v-model="edDtAgendamento" required />
                </div>

                <div class="form-item-coordenadas">
                    <CoordenadasSelect v-model:modelValueLatitude="edLatitude" v-model:modelValueLongitude="edLongitude" />
                </div>
            </div>


            <div v-if="showConfirmaHora" class="row-end">
                <label for="ckConfirmaHora">CONFIRMAR OS COM HORA EXCEDENTE</label>
                <input id="ckConfirmaHora" type="checkbox" class="input-checkbox" v-model="ckConfirmaHora" />
            </div>

            <div v-if="showConfirmaStatus" class="row-end">
                <label for="ckConfirmaStatus">CONFIRMAR OS COM PENDÊNCIAS DO SOLICITANTE</label>
                <input id="ckConfirmaStatus" type="checkbox" class="input-checkbox" v-model="ckConfirmaStatus" />
            </div>

            <div class="row-end">
                <label for="ckChuva">Pode ser executada com chuva</label>
                <input id="ckChuva" type="checkbox" class="input-checkbox" v-model="ckChuva" />
            </div>

            <div class="row-end">
                <label for="ckPossuiEquipamento">Possui equipamento</label>
                <input id="ckPossuiEquipamento" type="checkbox" class="input-checkbox" v-model="ckPossuiEquipamento" />
            </div>

            <div class="row-end margin-top10">
                <button class="btn-confirm" type="submit">Salvar</button>
                <button class="btn-cancel" type="cancel" @click="cancelForm">Cancelar</button>
            </div>
        </form>
    </div>

    <div v-if="showPessoaSelect">
        <PessoaPesquisaPage
            @close="cancelForm"
            @pessoaSelecionada="selecionarPessoa" />
    </div>

    <ModalFone
        :visible="showModalFone"
        @update:visible="(value) => (showModalFone = value)"
        @submit="redefinirFone" />

    <div v-if="showOsView">
        <OSViewPage :idView="idOsView" @close="closeForm" />
    </div>

    <CpfCnpjModal
        v-if="showModalCpfCnpj"
        @close="showModalCpfCnpj = false"
        @cpfCnpjSubmitted="arrumarCpfCnpj"
    />
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import { criarOs } from '@/models/Os';
import { Funcoes } from '@/funcoes/utils';
import { genericPost, genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import CoordenadasSelect from '@/components/CoordenadasSelect.vue';
import CpfCnpjModal from '@/components/modals/CpfCnpjModal.vue';
import CulturaSelect from '@/selects/CulturaSelect.vue';
import EquipamentoGrupoSelect from '@/selects/EquipamentoGrupoSelect.vue';
import EquipamentoSelect from '@/selects/EquipamentoSelect.vue';
import LocalidadeSelect from '@/selects/LocalidadeSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import ModalFone from '@/components/modals/ModalFone.vue';
import OSViewPage from './OSViewPage.vue';
import PessoaPesquisaPage from '../cadastros/pesquisas/PessoaPesquisaPage.vue';
import PropriedadeSelect from '@/selects/PropriedadeSelect.vue';
import ServicoSelect from '@/selects/ServicoSelect.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const showPropriedade = ref(false);

const ckChuva = ref(false);
const ckCpfCnpjOk = ref(true);
const ckPossuiEquipamento = ref(false);
const edDescricao = ref(null);
const edDtAgendamento = ref(null);
const edHectares = ref(null);
const edHrContratada = ref("");
const edHrCtBanco = ref("");
const edHrCtPagamento = ref("");
const edLatitude = ref(null);
const edLongitude = ref(null);
const edLocalidadeComplemento = ref(null);

const ckConfirmaHora = ref(false);
const ckConfirmaStatus = ref(false);
const msgAlerta = ref(null);
const isLoading = ref(false);
const idCultura = ref(null);
const idEquipamento = ref(null);
const idGrupo = ref(null);
const idImplemento = ref(null);
const idLocalidade = ref(null);
const idOperador = ref(0);
const idOsView = ref(0);
const idPropriedade = ref(0);
const idServico = ref(null);
const msgEdicao = ref(null);
const objEdicao = ref(criarOs());
const showConfirmaHora = ref(false);
const showConfirmaStatus = ref(false);
const showModalCpfCnpj = ref(false);
const showModalFone = ref(false);
const showOsView = ref(false);
const showPessoaSelect = ref(false);
const vlHora = ref(0);
const vlHoraImplemento = ref(0);
const vlTotal = ref(0);
const vlTotalFixado = ref(0);

// OBJETOS
const equipamentoSelecionado = ref(null);
const grupoSelecionado = ref(null);
const implementoSelecionado = ref(null);
const pessoaSelecionada = ref({});
const pessoaStatus = ref({});
const propriedadeSelecionada = ref(null);

async function arrumarCpfCnpj(value){
    showModalCpfCnpj.value=false;
    try{
        msgAlerta.value  = null;
        isLoading.value     = true;
        const r = await genericPut('/cad/pessoa', {
            id: pessoaSelecionada.value.id,
            cpfcnpj: value, 
            idusuario: globalStore.idusuario});
        if (r.bolok == 1){pessoaSelecionada.value.cpfcnpj = value; ckCpfCnpjOk.value=true;}else{msgAlerta.value = r.error}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally {isLoading.value = false;}
}

const atualizarEquipamento = (novoEquipamento) => {
    equipamentoSelecionado.value = novoEquipamento;
    if (equipamentoSelecionado.value.idoperador){idOperador.value = equipamentoSelecionado.value.idoperador;}
};

const atualizarGrupo = (novoGrupo) => {
    grupoSelecionado.value = novoGrupo;
    showPropriedade.value = grupoSelecionado.value.ckos_propriedade === 'S';
};

const atualizarImplemento = (novoImplemento) => {
    implementoSelecionado.value = novoImplemento;
};

const atualizarPropriedade = (novoObjeto) => {
    propriedadeSelecionada.value = novoObjeto;
    idPropriedade.value             = propriedadeSelecionada.value.id;
};

const atualizarVlTotal = () => {
    const horas                 = Funcoes.decimalFromTimeString(edHrContratada.value); // Converte string para número
    const horasCtBanco          = Funcoes.decimalFromTimeString(edHrCtBanco.value);
    const horasPagto            = (horas - horasCtBanco);
    showConfirmaHora.value      = (horas>10);
    edHrCtPagamento.value       = Funcoes.formatTimeFromDecimal(horasPagto);
    vlTotal.value               = (vlHora.value * horasPagto) + (vlHoraImplemento.value * horasPagto); // Calcula o total
};

const cancelForm = () => {emit('close');};

const closeForm = () => {
    showOsView.value=false;
    emit('close');
    emit('save');
};

const lerDados = async() =>{
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('os', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
                if (!objEdicao.value.idcobrancaitem){
                    msgEdicao.value='AVISO: EDIÇÃO DE ORDEM DE SERVIÇO';
                }else{
                    vlTotalFixado.value=objEdicao.value.vlhr_total;
                    msgEdicao.value=`AVISO: VALOR TOTAL FIXADO R$ ${Funcoes.formatDecimal(vlTotalFixado.value)}`;
                }

                // LER DADOS DA PESSOA
                const rPessoa = await genericPost('/listas/pessoas', {idmunicipio: globalStore.idmunicipio, id: objEdicao.value.idpessoa});
                pessoaSelecionada.value = rPessoa[0];
                lerPessoaStatus();

                // ATRIBUIÇÃO DAS VARIÁVEIS
                idCultura.value                 = objEdicao.value.idcultura;
                idGrupo.value                   = objEdicao.value.idequipamento_grupo;
                idEquipamento.value             = objEdicao.value.idequipamento;
                idImplemento.value              = objEdicao.value.idimplemento;
                idServico.value                 = objEdicao.value.idservico;
                idLocalidade.value              = objEdicao.value.idlocalidade;
                idPropriedade.value             = objEdicao.value.idpropriedade;
                edLocalidadeComplemento.value   = objEdicao.value.localidade_complemento;
                edHectares.value                = Funcoes.formatDecimal(objEdicao.value.hectares);
                edDtAgendamento.value           = objEdicao.value.dtinicioprevisto;
                edHrContratada.value            = objEdicao.value.hrcontratadas;
                edHrCtBanco.value               = objEdicao.value.hrctbanco;
                edDescricao.value               = objEdicao.value.descricao;
                ckPossuiEquipamento.value       = objEdicao.value.possuiequipamento === 1;
                ckChuva.value                   = objEdicao.value.chuva === 1;
                edLatitude.value                = objEdicao.value.latitude;
                edLongitude.value               = objEdicao.value.longitude;

                vlHora.value                    = objEdicao.value.vlhora1;
                vlHoraImplemento.value          = objEdicao.value.vlhr_implemento;
                atualizarVlTotal();                        

            }catch (error){msgAlerta.value='Erro leitura dos dados'}
        }else{
            showPessoaSelect.value=true;
            objEdicao.value.idmunicipio         = globalStore.idmunicipio;
            objEdicao.value.dtinclusao          = Funcoes.strDataAtual();
            objEdicao.value.tpdigitacao         = 1;
        }
    } catch (error) {msgAlerta.value=error;
    } finally {isLoading.value=false;}
    objEdicao.value.idlogin             = globalStore.idlogin;
    objEdicao.value.idusuario           = globalStore.idusuario;
}

const lerPessoaStatus = async() => {
    if (!pessoaSelecionada.value){
        pessoaStatus.value=null;
        return;
    }

    try{
        showConfirmaStatus.value        = false;
        msgAlerta.value              = null;
        const retOs = await genericPost('/dados/status_pessoa', {id: pessoaSelecionada.value.id});
        pessoaStatus.value=retOs[0];
        showConfirmaStatus.value        = (
            (pessoaStatus.value.financeiro_aemitir) || 
            (pessoaStatus.value.financeiro_vencido) || 
            (pessoaStatus.value.saldo_vlbanco < 0) ||
            (pessoaStatus.value.produtor_sn != 'S'));
        try{Funcoes.validarCNPJouCPF(pessoaSelecionada.value.cpfcnpj)}catch (error){ckCpfCnpjOk.value=false}
    }catch (error){ msgAlerta.value  = error;
    }finally{isLoading.value=false;}
}

const redefinirFone = async({fone}) =>{
    try{
        msgAlerta.value  = null;
        isLoading.value     = true;
        const r = await genericPut('/cad/pessoa', {
            id: pessoaSelecionada.value.id,
            fone: fone, 
            idusuario: globalStore.idusuario});
        if (r.bolok == 1){pessoaSelecionada.value.fone = fone}else{msgAlerta.value = r.error}
    }finally {isLoading.value = false;}
}

const selecionarPessoa = (novaPessoa) => {
    pessoaSelecionada.value = novaPessoa; // Atualiza o valor da ref
    idLocalidade.value = pessoaSelecionada.value.idlocalidade;
    showPessoaSelect.value = false; // Fecha a tela de seleção
    lerPessoaStatus();
};

const submitForm = async () => {
    try{
        msgAlerta.value                         = null;
        if (showPropriedade.value && !propriedadeSelecionada.value) throw new Error('Informe a propriedade');
        const mnContratados                     = Math.trunc(Funcoes.decimalFromTimeString(edHrContratada.value)*60);
        const mnCtBanco                         = Math.trunc(Funcoes.decimalFromTimeString(edHrCtBanco.value)*60);
        if ((edHrContratada.value.length != 5) || (mnContratados < 30)){
            msgAlerta.value                     = 'Informe horas contratadas corretamente. Mínimo permitido são 30 minutos';
            return;
        }
        if ((mnContratados>600) && (!ckConfirmaHora.value)){
            msgAlerta.value                     = 'Necessário confirmar horas excedentes ao padrão';
            return;
        }
        if (mnCtBanco > pessoaStatus.value.saldo_minutos){
            msgAlerta.value                     = 'Saldo informado de bonificação maior que saldo do produtor';
            return;
        }
        if ((showConfirmaStatus.value) && (!ckConfirmaStatus.value)){
            msgAlerta.value                     = 'Necessário confirmar emissão com pendências do solicitante';
            return;
        }
        if ((vlTotalFixado.value > 0) && (vlTotalFixado.value != vlTotal.value)){
            msgAlerta.value                     = 'Não é permitido alteração do valor total da OS';
            return;
        }
        
        isLoading.value                         = true;
        objEdicao.value.idequipamento_grupo     = idGrupo.value;
        objEdicao.value.idequipamento           = idEquipamento.value??1;
        objEdicao.value.idimplemento            = idImplemento.value;
        objEdicao.value.idservico               = idServico.value;
        objEdicao.value.idpessoa                = pessoaSelecionada.value.id;
        objEdicao.value.idpropriedade           = Funcoes.getId(propriedadeSelecionada);
        objEdicao.value.idlocalidade            = (showPropriedade.value) ? propriedadeSelecionada.value.idlocalidade : idLocalidade.value;
        objEdicao.value.idcultura               = idCultura.value;
        objEdicao.value.localidade_complemento  = edLocalidadeComplemento.value;
        objEdicao.value.hectares                = Funcoes.decimalFromString(edHectares.value);
        objEdicao.value.dtinicioprevisto        = edDtAgendamento.value;
        objEdicao.value.hrinicioprevisto        = '08:00';
        objEdicao.value.mncontratados           = mnContratados;
        objEdicao.value.mnctbanco               = mnCtBanco;
        objEdicao.value.descricao               = edDescricao.value;
        objEdicao.value.possuiequipamento       = ckPossuiEquipamento.value ? 1 : 0;
        objEdicao.value.agendado                = 0; //todo
        objEdicao.value.chuva                   = ckChuva.value ? 1 : 0;
        objEdicao.value.latitude                = !edLatitude.value ? 0 : parseFloat(edLatitude.value.toString().replace(',', '.')) || 0;
        objEdicao.value.longitude               = !edLongitude.value ? 0 : parseFloat(edLongitude.value.toString().replace(',', '.')) || 0;

        const retOs = await genericPut('/cad/os', objEdicao.value);
        if (retOs.bolok==1){
            idOsView.value=retOs.id;
            showOsView.value=true;
        }else{
            msgAlerta.value = `ATENÇÃO: ${retOs.erro}`;
        }
    }catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

watch(edHrContratada, () => {
    atualizarVlTotal();
});

watch(edHrCtBanco, () => {
    atualizarVlTotal();
});

watch(equipamentoSelecionado, (novoObjeto) => {
    if (novoObjeto  && (Funcoes.decimalFromString(novoObjeto.vlhora)>0)) {
        vlHora.value = novoObjeto.vlhora || 0;
        atualizarVlTotal();
    }
});

watch(grupoSelecionado, (novoObjeto) => {
    if (novoObjeto) {
        vlHora.value = novoObjeto.vlhora || 0;
        edDtAgendamento.value = novoObjeto.dtprevisao;
        atualizarVlTotal();
    }
});

watch(implementoSelecionado, (novoObjeto) => {
    if (novoObjeto) {
        vlHoraImplemento.value = novoObjeto.vlhora || 0;
        atualizarVlTotal();
    }
});

onMounted(lerDados);
</script>